export const timeZone = [
  {
    label: '(UTC) Dublin, Edinburgh, Lisbon, London',
    value: '(UTC) Dublin, Edinburgh, Lisbon, London',
  },
  {
    label: '(UTC+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna',
    value: '(UTC+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna',
  },
  {
    label: '(UTC+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius',
    value: '(UTC+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius',
  },
  {
    label: '(UTC+03:00) Kuwait, Riyadh',
    value: '(UTC+03:00) Kuwait, Riyadh',
  },
  {
    label: '(UTC+04:00) Moscow, St. Petersburg, Volgograd',
    value: '(UTC+04:00) Moscow, St. Petersburg, Volgograd',
  },
  {
    label: '(UTC+05:00) Islamabad, Karachi',
    value: '(UTC+05:00) Islamabad, Karachi',
  },
  {
    label: '(UTC+06:00) Ekaterinburg',
    value: '(UTC+06:00) Ekaterinburg',
  },
  {
    label: '(UTC+07:00) Bangkok, Hanoi, Jakarta',
    value: '(UTC+07:00) Bangkok, Hanoi, Jakarta',
  },
  {
    label: '(UTC+08:00) Krasnoyarsk',
    value: '(UTC+08:00) Krasnoyarsk',
  },
  {
    label: '(UTC+09:00) Osaka, Sapporo, Tokyo',
    value: '(UTC+09:00) Osaka, Sapporo, Tokyo',
  },
  {
    label: '(UTC-01:00) Azores',
    value: '(UTC-01:00) Azores',
  },
  {
    label: '(UTC-02:00) Mid-Atlantic',
    value: '(UTC-02:00) Mid-Atlantic',
  },
  {
    label: '(UTC-03:00) Buenos Aires',
    value: '(UTC-03:00) Buenos Aires',
  },
  {
    label: '(UTC-04:00) Asuncion',
    value: '(UTC-04:00) Asuncion',
  },
  {
    label: '(UTC-05:00) Bogota, Lima, Quito',
    value: '(UTC-05:00) Bogota, Lima, Quito',
  },
  {
    label: '(UTC-06:00) Central Time (US & Canada)',
    value: '(UTC-06:00) Central Time (US & Canada)',
  },
  {
    label: '(UTC-07:00) Chihuahua, La Paz, Mazatlan',
    value: '(UTC-07:00) Chihuahua, La Paz, Mazatlan',
  },
  {
    label: '(UTC-08:00) Pacific Time (US & Canada)',
    value: '(UTC-08:00) Pacific Time (US & Canada)',
  },
];
